import reactDom from "react-dom";
import { Provider } from "react-redux";
import { store } from "../../redux/store";
import ErrorToast from "./ErrorToast";
import InfoToast from "./InfoToast";
import SuccessToast from "./SuccessToast";
import Toast from "./Toast";
import WarningToast from "./WarningToast";

export const displayToast = (data) => {
  let component;
  switch (data.type) {
    case "error":
      component = <ErrorToast toastKey={Math.random()} {...data} />;
      break;
    case "success":
      component = <SuccessToast toastKey={Math.random()} {...data} />;
      break;
    case "warn":
      component = <WarningToast toastKey={Math.random()} {...data} />;
      break;
    case "info":
      component = <InfoToast toastKey={Math.random()} {...data} />;
      break;
    default:
      component = <Toast toastKey={Math.random()} content={data.content} />;
  }
  reactDom.render(
    <Provider store={store}>{component}</Provider>,
    document.getElementById("toast-overlay")
  );
};
